import { useState } from "react";
import { CancelDialog } from "./ReturnCancelDialog";
import { DownloadDocumentBtn } from "../../components/DownloadDocumentBtn";
// MUI
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

export const ReturnHeader = ({ no, status }) => {
  const [open, setOpen] = useState(false);
  const handleCancelDialogOpen = () => setOpen(true);
  const handleCancelDialogClose = () => setOpen(false);

  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h5">Return Order - {no}</Typography>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            color="error"
            onClick={handleCancelDialogOpen}
            disabled={status === "Released"}
          >
            Cancel Return
          </Button>

          <DownloadDocumentBtn
            docType="PDF"
            docNo={no}
            path="printreturnorder"
          />
        </Stack>
      </Stack>
      <CancelDialog no={no} open={open} handleClose={handleCancelDialogClose} />
    </>
  );
};
